import * as types from '../mutation-types'
import {
    check_coupon,
    submit_order,
    calc_promotion,
    calc_delivery_fee

} from '@/api/order';
export const state = {
    order: [],
    quantity: 0,
    couponAmount: 0,
    apply_loading_coupon: false,
    state_order: false,
    loading: false,
    pending_order: {},
    order_info: {
        room_number: 0,
        customer_first_name: "",
        location: "",
        lat: '',
        lng: ''
    },
    sale_id: 0,
    order_completed: false,
    promotion: {},
    promotion_amount: 0,
    loading_promotion: false,
    loading_delivery_fee: false,
    delivery_fee: {},
}

export const getters = {
    order: state => state.order,
    quantity: state => state.quantity,
    couponAmount: state => state.couponAmount,
    apply_loading_coupon: state => state.apply_loading_coupon,
    state_order: state => state.state_order,
    loading: state => state.loading,
    pending_order: state => state.pending_order,
    sale_id: state => state.sale_id,
    order_completed: state => state.order_completed,
    order_info: state => state.order_info,
    promotion: state => state.promotion,
    promotion_amount: state => state.promotion_amount,
    loading_promotion: state => state.loading_promotion,
    delivery_fee: state => state.delivery_fee,
    loading_delivery_fee: state => state.loading_delivery_fee,
}

export const mutations = {


    [types.CALC_DILIVERY](state, payload) {
        state.loading_delivery_fee = true;
    },
    [types.CALC_DILIVERY_FAIL](state, payload) {
        state.loading_delivery_fee = false;
        state.delivery_fee = {};
    },
    [types.CALC_DILIVERY_SUCCESS](state, payload) {
        state.loading_delivery_fee = false;
        state.delivery_fee = payload;
    },


    [types.CALC_PROMOTION](state, payload) {
        state.loading_promotion = true;
    },
    [types.CALC_PROMOTION_FAIL](state, payload) {
        state.loading_promotion = false;
        state.promotion_amount = 0;
    },
    [types.CALC_PROMOTION_SUCCESS](state, payload) {
        state.loading_promotion = false;
        state.promotion_amount = payload;
    },


    [types.ORDERINFOR](state, payload) {
        state.order_info = payload;
    },
    [types.SALE_ID](state, payload) {
        state.sale_id = payload;
    },
    [types.ORDER](state, payload) {
        state.order = payload;
        state.state_order = false;
    },
    [types.ORDER_PENDING](state, payload) {
        state.pending_order = payload;
    },
    [types.ORDER_COMPLETED](state, payload) {
        state.order_completed = payload;
    },
    [types.COUPON](state, payload) {
        state.apply_loading_coupon = true
    },
    [types.COUPON_FAIL](state, payload) {
        state.apply_loading_coupon = false;
        state.couponAmount = 0;
    },
    [types.COUPON_SUCCESS](state, payload) {
        state.apply_loading_coupon = false;
        state.couponAmount = payload;
    },
    [types.SUBMIT_ORDER](state, payload) {
        state.loading = true
    },
    [types.SUBMIT_ORDER_FAIL](state, payload) {
        state.loading = false;
        state.state_order = false;
    },
    [types.SUBMIT_ORDER_SUCCESS](state, payload) {
        state.loading = false;
        state.state_order = true;
        state.sale_id = payload.sale_id;
        state.order_completed = true;
    },
    [types.APPLY_PROMOTION](state, payload) {
        state.promotion = payload
    }
}
export const actions = {
    applyPromotion({ commit }, payload) {
        commit(types.APPLY_PROMOTION, payload);
    },
    setOrderInfo({ commit, getters }, payload) {
        commit(types.ORDERINFOR, payload);
    },
    clearOrderInfo({ commit }, payload) {

        commit(types.ORDERINFOR, {
            room_number: null,
            customer_first_name: null,
            location: null,
            lng: null,
            lat: null,
            customer_phone_number: null,
            receiver_name: null,
        });
    },
    async ApplyCouponCode({ commit, getters }, payload) {
        commit(types.COUPON);
        try {
            let data = await check_coupon(payload);
            commit(types.COUPON_SUCCESS, data.coupon_amount);
        } catch (error) {
            commit(types.COUPON_FAIL);
        }

    },

    async CalcDeliveryFee({ commit, getters }, payload) {
        commit(types.CALC_DILIVERY);
        try {
            let data = await calc_delivery_fee(payload);
            commit(types.CALC_DILIVERY_SUCCESS, data);
        } catch (error) {
            commit(types.CALC_DILIVERY_FAIL);
        }
    },

    async CalcPromotion({ commit, getters }, payload) {
        commit(types.CALC_PROMOTION);
        try {
            const data = await calc_promotion(payload); 
            commit(types.CALC_PROMOTION_SUCCESS, data);
        } catch (error) {  
            commit(types.CALC_PROMOTION_FAIL);
            throw error
        }
    },
    clearStateOrder({ commit }, payload) {
        commit(types.ORDER_COMPLETED, false);
    },
    clearOrder({ commit, getters }, payload) {
        commit(types.ORDER, []);
        commit(types.CALC_DILIVERY_FAIL);
        commit(types.ORDER_PENDING, {});
        // clear promotion
        commit(types.APPLY_PROMOTION, {});
        commit(types.CALC_PROMOTION_SUCCESS, 0);

        commit(types.ORDERINFOR, {
            room_number: null,
            customer_first_name: null,
            location: null,
            lng: null,
            lat: null,
            customer_phone_number: null,
            receiver_name: null,
        });
        localStorage.setItem('_action', null);
        localStorage.setItem('_slug', null);
    },
    setOrder({ commit, getters }, payload) {
        let data = getters.order;
        let find = _.findIndex(data, function (e) {
            return e.key_id === payload.key_id;
        })
        if (find > -1) {
            data[find].note=  payload.note
            data[find].qty = data[find].qty + payload.qty;
            data[find].total_price = Number(data[find].total_price) + Number(payload.total_price);

        } else {
            data.push(payload);
        }

        commit(types.ORDER, data);
    },
    removeItem({ commit, getters }, payload) {
        let index = _.findIndex(getters.order, function (el) {
            return el.key_id === payload.key_id;
        })
        getters.order.splice(index, 1);
        commit(types.ORDER, getters.order);

    },
    adjustItem({ commit, getters }, payload) {

        let data = getters.order;
        let find = _.findIndex(data, function (e) {
            return e.key_id === payload.key_id;
        });
        if (find > -1) {
            if (payload.plus) {
                data[find].qty = data[find].qty + 1;
                data[find].total_price = Number(data[find].total_price) + Number(data[find].key_price_per_set)
            }
            else {
                if (data[find].qty - 1 > 0) {
                    data[find].qty = data[find].qty - 1;
                    data[find].total_price = Number(data[find].total_price) - Number(data[find].key_price_per_set)
                }
            }

        }
        commit(types.ORDER, data);

    },
    async submitPendingOrder({ commit, getters }, payload) {
        let data = getters.pending_order; 
        let info = getters.order_info;
        data.customer_phone_number = info.customer_phone_number;
        data.receiver_name = info.receiver_name;
        data.lat = info.lat;
        data.lng = info.lng;
        data.location_id = info.location_id; 
        data.location = info.location;
        data.customer_first_name = info.customer_first_name;
        if (info.room_number) {
            data.room_number = info.room_number.id
        } 
        commit(types.SUBMIT_ORDER);
        try {
            let respone = await submit_order(data);

            commit(types.SUBMIT_ORDER_SUCCESS, respone);

        } catch (error) {
            commit(types.SUBMIT_ORDER_FAIL);
        }
    },
    async submitOrder({ commit, getters }, payload) {
        let data = {
            items: [],
            total: payload.total,
            sub_total: payload.sub_total,
            discount: payload.discount,
            coupon: payload.coupon,
            note: payload.note,
            type_id: payload.type_id,
            type: 'restaurant',
            currency_id: payload.currency_id,
            exchangerate: payload.exchangerate,
            order_type: payload.order_type,
            promotion_id: payload.promotion_id,
            payment_method: payload.payment_method,
            pickup_datetime: payload.pickup_datetime
        };

        _.forEach(getters.order, function (el) {
            let item = {
                item_id: el.item_id,
                qty: el.qty,
                price: el.price,
                options: [],
                note: el.note,
            }
            _.forEach(el.options, function (ell) {
                let options = {
                    option_id: ell.option_id,
                    optionvalues: []
                }
                _.forEach(ell.optionvalues, function (elll) {
                    options.optionvalues.push({ id: elll.opion_value_id })
                });
                item.options.push(options);
            });
            data.items.push(item);

        });
        if (payload.local_status === 'pending') {
            commit(types.ORDER_PENDING, data);
            return;
        }
        commit(types.SUBMIT_ORDER);
        try {
            let respone = await submit_order(data);

            commit(types.SUBMIT_ORDER_SUCCESS, respone);

        } catch (error) {
            commit(types.SUBMIT_ORDER_FAIL);
        }

    },
    clearSaleId({ commit }, payload) {
        commit(types.SALE_ID, 0);
    },
    setSaleId({ commit }, payload) {
        commit(types.SALE_ID, payload);
    }
}
